<template>
  <div>
    <strong>{{
      rule.config.action == 1
        ? 'Only invest in'
        : rule.config.action == 2
          ? 'Do not invest in'
          : 'UNANSWERED'
    }}</strong>
    sectors that have <strong>{{ rule.config.above_below }}</strong> the S&amp;P TR by at least
    <strong>{{ rule.config.threshold }} percentage points</strong> over the past
    <strong>{{ GetSandPDays(rule.config.days) }}</strong> days. Restrict to these sectors only:
    <ul>
      <li v-for="s in rule.config.sector_ids" :key="s">
        {{ GetSector(s) }}
      </li>
    </ul>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  data() {
    return {
      stocks_vs_sp_months: [
        { text: '20 trading days', value: 1 },
        { text: '60 trading days', value: 3 },
        { text: '120 trading days', value: 6 },
        { text: '180 trading days', value: 9 },
        { text: '240 trading days', value: 12 },
        { text: '480 trading days', value: 24 }
      ],
      comparisons: [
        { id: 206787, description: 'Communications (XLC)' },
        { id: 5962, description: 'Consumer Discretionary (XLY)' },
        { id: 6764, description: 'Consumer Staples (XLP)' },
        { id: 4145, description: 'Energy (XLE)' },
        { id: 5963, description: 'Financials (XLF)' },
        { id: 5961, description: 'Health Care (XLV)' },
        { id: 4180, description: 'Industrials (XLI)' },
        { id: 5910, description: 'Materials (XLB)' },
        { id: 191504, description: 'Real Estate (XLRE)' },
        { id: 5593, description: 'Technology (XLK)' },
        { id: 5018, description: 'Utilities (XLU)' }
      ]
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  created() {},

  methods: {
    GetSandPDays(id) {
      var found = null
      for (var i = 0; i < this.stocks_vs_sp_months.length; i++) {
        var s = this.stocks_vs_sp_months[i]
        if (s.value == id) {
          found = s.text
          break
        }
      }
      return found
    },
    GetSector(id) {
      var found = null
      for (var i = 0; i < this.comparisons.length; i++) {
        var s = this.comparisons[i]
        if (s.id == id) {
          found = s.description
          break
        }
      }
      return found
    }
  }
}
</script>
